/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const deliveryCourierSchema = z.object({
	name: z.string(),
	phone: z.string().nullable().describe("Только если точка разрешила показывать телефон курьера."),
});
